import { render, staticRenderFns } from "./fixedColumnsTable.vue?vue&type=template&id=2cb30195&scoped=true&"
import script from "./fixedColumnsTable.vue?vue&type=script&lang=js&"
export * from "./fixedColumnsTable.vue?vue&type=script&lang=js&"
import style0 from "./fixedColumnsTable.vue?vue&type=style&index=0&id=2cb30195&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb30195",
  null
  
)

export default component.exports